var map = {
	"./1.png": 979,
	"./10.png": 854,
	"./11.png": 526,
	"./12.png": 84,
	"./13.png": 252,
	"./2.png": 538,
	"./3.png": 254,
	"./4.png": 444,
	"./5.png": 415,
	"./6.png": 859,
	"./7.png": 322,
	"./8.png": 445,
	"./9.png": 861
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 770;